import { useCallback, useEffect, useImperativeHandle } from 'react';
// Custom hooks.
// -----------------------------------------------------------------------------
export const useModal = ({ disableEscKey, disableOutsideClick, isOpen, onClose, ref, refModal }) => {
    // Hooks.
    // ---------------------------------------------------------------------------
    useImperativeHandle(ref, () => refModal.current);
    // Effect.
    // ---------------------------------------------------------------------------
    useEffect(() => {
        // Esc Key
        const handleOnEsc = (event) => {
            if (!disableEscKey && event.key === 'Escape') {
                event.preventDefault();
                handleOnClickCross();
            }
        };
        // Outside Click.
        const handleOutsideClick = (event) => {
            if (!disableOutsideClick) {
                const divModal = refModal.current;
                if (divModal && !divModal.contains(event.target)) {
                    event.preventDefault();
                    handleOnClickCross();
                }
            }
        };
        if (isOpen) {
            document.addEventListener('click', handleOutsideClick);
            document.addEventListener('keydown', handleOnEsc);
        }
        else {
            document.removeEventListener('click', handleOutsideClick);
            document.removeEventListener('keydown', handleOnEsc);
        }
        return () => {
            document.removeEventListener('keydown', handleOnEsc);
            document.removeEventListener('click', handleOutsideClick);
        };
    }, [isOpen]);
    // Handlers.
    // ---------------------------------------------------------------------------
    const handleOnClickCross = useCallback(() => {
        onClose?.();
    }, [onClose]);
    // Return.
    // ---------------------------------------------------------------------------
    return {
        onClickCross: handleOnClickCross
    };
};
//# sourceMappingURL=Modal.hooks.js.map